import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from '../Title';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function EstadoTurnosProfesionalCentro() {
  const classes = useStyles();

  const { itemsEstadoTurnos } = useSelector( (state) => state.indicadores );

  return (
    <React.Fragment>
      <Title>Estado Turnos Libres / Tomados por Centro y Profesional por día</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Profesional</TableCell>
            <TableCell>Especialidad</TableCell>
            <TableCell>Centro Médico</TableCell>
            <TableCell align="right">Tomados</TableCell>
            <TableCell align="right">Libres</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {itemsEstadoTurnos.map((row, i) => (
            <TableRow key={i}>
              <TableCell>{row.nombreProfesional}</TableCell>
              <TableCell>{row.descripcionEspecialidad}</TableCell>
              <TableCell>{row.descripcionCentroMedico}</TableCell>
              <TableCell align="right">{row.tomados}</TableCell>
              <TableCell align="right">{row.libres}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        {/* <Link color="primary" href="#" onClick={preventDefault}>
           Ampliar 
        </Link> */}
      </div>
    </React.Fragment>
 
  );
}